import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

interface HomePageProps {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
}

const HomePage: React.FC<HomePageProps> = ({ theme, toggleTheme }) => {
  const navigate = useNavigate();

  const categories = [
    {
      title: 'Scalability',
      description: 'Learn about horizontal and vertical scaling, load balancing, and caching strategies',
      icon: '📈'
    },
    {
      title: 'Database Design',
      description: 'Master SQL vs NoSQL, sharding, replication, and database optimization',
      icon: '🗄️'
    },
    {
      title: 'Microservices',
      description: 'Understand microservices architecture, API gateways, and service mesh',
      icon: '🔧'
    },
    {
      title: 'Distributed Systems',
      description: 'Explore CAP theorem, consistency patterns, and distributed consensus',
      icon: '🌐'
    }
  ];

  return (
    <div className="home-page">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">System Design Hub</h1>
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>
      </header>

      <main className="main-content">
        <section className="hero">
          <h2 className="hero-title">Master System Design</h2>
          <p className="hero-description">
            Comprehensive articles and guides to help you understand and design scalable systems
          </p>
        </section>

        <section className="categories">
          <h3 className="section-title">Article Categories</h3>
          <div className="category-grid">
            {categories.map((category, index) => (
              <div key={index} className="category-card">
                <span className="category-icon">{category.icon}</span>
                <h4 className="category-title">{category.title}</h4>
                <p className="category-description">{category.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section">
          <button className="view-all-btn" onClick={() => navigate('/articles')}>
            View All Articles
          </button>
        </section>
      </main>

      <footer className="footer">
        <p>&copy; 2026 System Design Hub. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
